import { jsx as _jsx } from "react/jsx-runtime";
import { Loader2 } from 'lucide-react';
import { cn } from '@repo/ui-primitives/utils';
/**
 * Simple loading spinner component (centered by default).
 * Uses lucide-react Loader2 icon with rotation animation.
 */ export const Loading = (param)=>{
    let { className } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn('flex items-center justify-center', className),
        children: /*#__PURE__*/ _jsx(Loader2, {
            className: "h-8 w-8 animate-spin text-primary"
        })
    });
};
